import { ITicker } from '@kattana-io/common';
import { action } from 'typesafe-actions';

const entity = 'current';

const SWITCH = `${entity}/SWITCH`;

const actionSwitchCurrent = (payload: ITicker) => action(SWITCH, payload);

export { SWITCH, actionSwitchCurrent };
